export const DoubleArrowRight = ({ className }: { className?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.561 5.43945L11.439 7.56145L16.379 12.5005L11.439 17.4395L13.561 19.5615L20.621 12.5005L13.561 5.43945Z"
        fill="white"
      />
      <path
        d="M6.56096 19.5615L13.621 12.5005L6.56096 5.43945L4.43896 7.56145L9.37896 12.5005L4.43896 17.4395L6.56096 19.5615Z"
        fill="white"
      />
    </svg>
  );
};
